import { render, staticRenderFns } from "./nh-sort-button.vue?vue&type=template&id=a0012682&scoped=true&"
import script from "./nh-sort-button.vue?vue&type=script&lang=js&"
export * from "./nh-sort-button.vue?vue&type=script&lang=js&"
import style0 from "./nh-sort-button.vue?vue&type=style&index=0&id=a0012682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0012682",
  null
  
)

export default component.exports